<template>
    <material-card full-header>
        <template #heading>
            <v-toolbar color="primary">
                <v-toolbar-title>
                    <v-icon> mdi-account-multiple </v-icon>
                    {{ $t('users') }}
                </v-toolbar-title>
                <v-spacer />
                <v-btn text icon dark class="mb-2" @click="close">
                    <v-icon medium>mdi-close-circle-outline</v-icon>
                </v-btn>
            </v-toolbar>
        </template>
        <v-data-table :headers="usersHeaders" :items="usersList" :search="search" class="elevation-1">
            <template v-slot:top>
                <v-toolbar flat>
                    <v-toolbar-title>{{ $t('search') }}</v-toolbar-title>
                    <v-text-field class="mx-2" v-model="search" append-icon="mdi-magnify" single-line
                        hide-details></v-text-field>
                    <v-spacer></v-spacer>
                </v-toolbar>
            </template>
        </v-data-table>
    </material-card>
</template>
<script>
import axios from "axios";
export default ({
    name: 'SessionUser',
    props: ['roomId'],
    data() {
        return {
            usersHeaders: [
                { text: this.$t("name"), value: "name" },
                { text: this.$t("mobile"), value: "mobile" },
                { text: this.$t("email"), value: "email" },
            ],
            usersList: [],
            totalRows: 0,
            loading: false,
            search: ''
        }
    },
    methods: {
        getUsers() {
            if (this.roomId) {
                this.loading = true;
                const payload = { _startRow: 0, _endRow: 10000 };
                axios({
                    url: process.env.VUE_APP_BACKEND_URL + "/api/webinar_plus/rooms/" + this.roomId + "/users",
                    method: 'GET',
                    headers: {
                        // 'Content-Type': 'multipart/form-data',
                        Authorization: this.$store.get("login/token"),
                    },
                    params: payload,

                }).then(response => {
                    console.log("data", response.data.data)
                    const data = response.data.response.data;
                    this.usersList = data;
                    this.totalRows = data.length;
                    this.loading = false;
                });
            }
        },
        close() {
            this.$emit('close')
        },
    },
    mounted() {
        this.getUsers()
    },
})
</script>
